/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
export default class AlertBoxes {
  static init () {
    this.el = $('[data-disappear-soon]')
    if (!(this.el.length > 0)) { return }
    return setTimeout(() => {
      return this.el.hide('slow')
    }
    , 4000)
  }
}
